export const ConfluenceLogoNeutral = () => (
  <svg
    width="267"
    height="48"
    viewBox="0 0 267 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M70.296 37.4057C68.41 38.6477 65.42 39.1997 62.291 39.1997C52.354 39.1997 46.741 33.2197 46.741 23.6957C46.741 14.4957 52.354 8.05371 62.199 8.05371C65.143 8.05371 68.088 8.60671 70.25 10.1697V14.1727C68.088 12.7927 65.695 12.0567 62.199 12.0567C55.114 12.0567 50.882 16.7487 50.882 23.6957C50.882 30.6427 55.253 35.2437 62.43 35.2437C65.604 35.2437 68.088 34.5077 70.296 33.4037V37.4057Z"
      fill="#44546F"
    />
    <path
      d="M73.192 27.1929C73.192 20.2919 77.24 15.2769 84.141 15.2769C90.995 15.2769 94.998 20.2919 94.998 27.1929C94.998 34.0939 90.995 39.1999 84.141 39.1999C77.24 39.1999 73.192 34.0939 73.192 27.1929ZM77.056 27.1929C77.056 31.5629 79.218 35.5199 84.141 35.5199C89.017 35.5199 91.133 31.5629 91.133 27.1929C91.133 22.8229 89.017 18.9579 84.141 18.9579C79.218 18.9579 77.056 22.8219 77.056 27.1929Z"
      fill="#44546F"
    />
    <path
      d="M119.148 38.7399H115.191V24.8459C115.191 20.7049 113.535 18.8659 109.762 18.8659C106.082 18.8659 103.552 21.3039 103.552 25.9509V38.7399H99.595V15.7379H103.552V19.5099C105.024 16.7949 107.738 15.2769 110.821 15.2769C116.111 15.2769 119.148 18.9119 119.148 25.2599V38.7389V38.7399Z"
      fill="#44546F"
    />
    <path
      d="M130.139 15.7378H136.073V19.4178H130.139V38.7398H126.275V19.4178H122.548V15.7378H126.275V13.2078C126.275 8.92879 128.668 6.02979 133.589 6.02979C134.785 6.02979 135.568 6.21478 136.258 6.39778V10.0328C135.568 9.89478 134.694 9.80279 133.774 9.80279C131.336 9.80279 130.14 11.2298 130.14 13.2998V15.7378H130.139Z"
      fill="#44546F"
    />
    <path
      d="M146.515 38.8786C142.743 38.8786 140.35 37.0836 140.35 32.8516V6.12256H144.307V32.3916C144.307 34.4616 145.687 35.1986 147.389 35.1986C147.803 35.1986 148.078 35.1986 148.539 35.1526V38.6946C148.217 38.7866 147.526 38.8796 146.515 38.8796V38.8786Z"
      fill="#44546F"
    />
    <path
      d="M151.896 15.7378H155.852V29.6318C155.852 33.7718 157.508 35.6118 161.281 35.6118C164.962 35.6118 167.492 33.1738 167.492 28.5268V15.7378H171.449V38.7398H167.492V34.9678C166.02 37.6828 163.305 39.1998 160.223 39.1998C154.932 39.1998 151.896 35.5658 151.896 29.2178V15.7378Z"
      fill="#44546F"
    />
    <path
      d="M188.42 39.1999C179.817 39.1999 176.045 34.2319 176.045 27.1929C176.045 20.2459 179.909 15.2769 186.902 15.2769C193.986 15.2769 196.839 20.1999 196.839 27.1929V28.9869H180.047C180.6 32.8969 183.13 35.4269 188.559 35.4269C191.227 35.4269 193.481 34.9209 195.551 34.1849V37.8199C193.665 38.8319 190.767 39.1999 188.42 39.1999ZM180.001 25.5829H192.837C192.607 21.3049 190.675 18.8659 186.718 18.8659C182.531 18.8659 180.415 21.5799 180.001 25.5829Z"
      fill="#44546F"
    />
    <path
      d="M221.081 38.7399H217.124V24.8459C217.124 20.7049 215.468 18.8659 211.695 18.8659C208.015 18.8659 205.485 21.3039 205.485 25.9509V38.7399H201.528V15.7379H205.485V19.5099C206.957 16.7949 209.671 15.2769 212.754 15.2769C218.044 15.2769 221.081 18.9119 221.081 25.2599V38.7389V38.7399Z"
      fill="#44546F"
    />
    <path
      d="M242.839 38.1419C241.458 38.8779 239.342 39.1999 237.226 39.1999C229.038 39.1999 225.219 34.2319 225.219 27.1929C225.219 20.2459 229.037 15.2769 237.226 15.2769C239.296 15.2769 240.907 15.5529 242.701 16.3809V20.0619C241.229 19.3719 239.665 18.9579 237.503 18.9579C231.523 18.9579 229.084 22.7299 229.084 27.1929C229.084 31.6559 231.568 35.4269 237.595 35.4269C239.942 35.4269 241.413 35.1059 242.84 34.5989V38.1419H242.839Z"
      fill="#44546F"
    />
    <path
      d="M258.339 39.1999C249.736 39.1999 245.964 34.2319 245.964 27.1929C245.964 20.2459 249.828 15.2769 256.821 15.2769C263.905 15.2769 266.758 20.1999 266.758 27.1929V28.9869H249.966C250.519 32.8969 253.049 35.4269 258.478 35.4269C261.146 35.4269 263.4 34.9209 265.47 34.1849V37.8199C263.584 38.8319 260.686 39.1999 258.339 39.1999ZM249.92 25.5829H262.756C262.526 21.3049 260.594 18.8659 256.637 18.8659C252.45 18.8659 250.334 21.5799 249.92 25.5829Z"
      fill="#44546F"
    />
    <path
      d="M1.168 31.3314C0.828996 31.8834 0.443996 32.5304 0.144996 33.0394C-0.143004 33.5304 0.0119962 34.1614 0.496996 34.4604L7.291 38.6534C7.789 38.9604 8.441 38.8024 8.738 38.2984C9.008 37.8414 9.358 37.2534 9.74 36.6214C12.433 32.1774 15.141 32.7194 20.02 35.0384L26.758 38.2414C27.289 38.4944 27.924 38.2584 28.163 37.7204L31.399 30.4144C31.629 29.8944 31.403 29.2874 30.889 29.0454C29.466 28.3764 26.638 27.0414 24.106 25.8154C14.905 21.3604 7.12 21.6554 1.168 31.3314Z"
      fill="url(#paint0_linear_2304_2980)"
    />
    <path
      d="M31.635 14.7276C31.974 14.1756 32.359 13.5286 32.658 13.0196C32.946 12.5286 32.791 11.8976 32.306 11.5986L25.512 7.40562C25.014 7.09862 24.362 7.25662 24.065 7.76062C23.795 8.21762 23.445 8.80561 23.063 9.43761C20.37 13.8816 17.662 13.3396 12.783 11.0206L6.045 7.81762C5.514 7.56462 4.879 7.80061 4.64 8.33861L1.404 15.6446C1.174 16.1646 1.4 16.7716 1.914 17.0136C3.337 17.6826 6.165 19.0176 8.697 20.2436C17.897 24.6986 25.682 24.4046 31.634 14.7276H31.635Z"
      fill="url(#paint1_linear_2304_2980)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2304_2980"
        x1="31.198"
        y1="40.8054"
        x2="10.638"
        y2="28.9914"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2304_2980"
        x1="1.604"
        y1="5.25362"
        x2="22.164"
        y2="17.0676"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
